import {mapRecordToItems} from '@/helpers/mapRecordToItems.helper';

export enum GenderTypes {
    MALE, FEMALE, TRANS, FAMILY,
}

export namespace GenderTypes {
    type Data = {
        text: string;
        salutation?: string;
        icon: string;
    }

    export const Record: Record<GenderTypes, Data> = {
        [GenderTypes.MALE]: {
            text: 'Männlich',
            salutation: 'Herr',
            icon: 'mdi-gender-male',
        },
        [GenderTypes.FEMALE]: {
            text: 'Weiblich',
            salutation: 'Frau',
            icon: 'mdi-gender-female',
        },
        [GenderTypes.TRANS]: {
            text: 'Divers',
            icon: 'mdi-gender-non-binary',
        },
        [GenderTypes.FAMILY]: {
            text: 'Familie',
            salutation: 'Familie',
            icon: 'mdi-human-male-female-child',
        },
    };

    export const Items = mapRecordToItems(Record);
}
